const winner = null

export const setWinner = (winner) => {
    return { type: 'SET_WINNER', data: winner }
}

export const clear = () => {
    return { type: 'CLEAR_WINNER' }
}

const reducer = (state = winner, action) => {
    switch (action.type) {
        case 'SET_WINNER':
            return action.data
        case 'CLEAR_WINNER':
            return null
        default: return state
    }
}

export default reducer